import { styled } from '@mui/material';
import Image from 'next/image';

export const StyledSecondaryLogoImage = styled(Image)({
  maxWidth: '300px',
  width: 'auto',
  maxHeight: '75px',
  height: 'auto',
});
